import { render, staticRenderFns } from "./Step2-Footer.vue?vue&type=template&id=5a930a9e&"
import script from "./Step2-Footer.vue?vue&type=script&lang=js&"
export * from "./Step2-Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports